import React, {useEffect, useState} from 'react';
import styles from "./styles.module.css";
import generalStyles from '../../../shared/pages/styles.module.css';
import { useLocation, useNavigate } from "react-router-dom";
import {parseLocationSearch} from "../../../../helpers/locationSearch";
import successIcon from '../../../../assets/images/successIcon.svg';
import {Button} from "../../../../components/general";
import {Loader} from "../../../../components/display/Loader/Loader";
import {PaymentDetailResponse} from "../../../../services/payment/payment.types";
import {getPaymentDetails, PaymentDetailsError} from "../../../../services/payment/payment.service";
import {describePaymentFailure} from "../../../../services/payment/ameriaFailure";

const AMERIA_SUCCESS_CODE = '00';

const FAILURE_MESSAGES: Record<PaymentDetailsError['reason'], string> = {
    timeout: 'Confirming your payment is taking longer than expected. If money was taken from your card, it will be confirmed or refunded automatically. Please contact us if you do not receive a confirmation.',
    network: 'We could not reach the payment service to confirm your payment. Please check your connection and try again.',
    server: 'We could not confirm your payment right now. If money was taken from your card, please contact us with your order details.',
};

const AmeriaBack:React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams =  parseLocationSearch(location.search);
    const [paymentDetails, setPaymentDetails] = useState<PaymentDetailResponse | undefined>();

    const fail = (message: string, title?: string) => {
        navigate('/ameria-error', { replace: true, state: { title, message, from: '/' } });
    }

    const init = async () => {
        const {paymentID, userId} = queryParams;

        let paymentDetail: PaymentDetailResponse;
        try {
            paymentDetail = await getPaymentDetails({
                userId: userId as number,
                PaymentID: `${paymentID}`,
            });
        } catch (e) {
            const reason = e instanceof PaymentDetailsError ? e.reason : 'network';
            fail(FAILURE_MESSAGES[reason]);
            return;
        }

        if (paymentDetail.ResponseCode === AMERIA_SUCCESS_CODE) {
            setPaymentDetails(paymentDetail);
            return;
        }

        const { title, message } = describePaymentFailure(paymentDetail);
        fail(message, title);
    }

    const navigateToHome = () => {
        window.location.href = `${process.env.REACT_APP_TECH_FOR_ALL_ORIGIN_URL}`;
    }

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            {
                 !paymentDetails ?
                    <Loader /> :
                    <div className={`${generalStyles.wrapper} ${styles.wrapper}`}>
                        <div className={styles.paymentPreviewWrapper}>
                            <div className={styles.success}>
                                <div className={styles.successMessage}>Payment Success!</div>
                                <img src={successIcon} alt="Success..."/>
                                <div className={styles.dashedLine}></div>
                            </div>
                            <div className={styles.paymentDetails}>
                                <div>
                                    <li>Reference Number</li>
                                    <span>{paymentDetails?.CardNumber}</span>
                                </div>
                                <div>
                                    <li>Date</li>
                                    <span>{paymentDetails.DateTime.split(' ')[0]}</span>
                                </div>
                                <div>
                                    <li>Time</li>
                                    <span>{paymentDetails.DateTime.split(' ')[1]}</span>
                                </div>
                                <div style={{ width: '40%', borderBottom: '1px dashed #DCDEE0'}}></div>
                                <div>
                                    <li>Amount</li>
                                    <span>{paymentDetails.Amount}</span>
                                </div>
                            </div>
                            <div className={styles.solidLine}></div>
                            <Button
                                style={{ marginTop: '54px' }}
                                type='submit'
                                styleType='primary'
                                disabled={false}
                                className={styles.receiptBtn}
                                onClick={navigateToHome}
                            >
                                Go Home
                            </Button>
                        </div>
                    </div>
            }
        </div>
    );
};

export default AmeriaBack;
